import React, { useState } from 'react';
import {
  Box,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  IconButton
} from '@mui/material';
import {
  Language,
  Check,
  ExpandMore
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const languages = [
  {
    code: 'en',
    name: 'English',
    flag: '🇺🇸',
    nativeName: 'English'
  },
  {
    code: 'zh',
    name: 'Chinese',
    flag: '🇨🇳',
    nativeName: '中文'
  }
];

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLanguageChange = (languageCode) => {
    i18n.changeLanguage(languageCode);
    handleClose();
  };

  return (
    <Box>
      <IconButton
        onClick={handleClick}
        color="inherit"
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          padding: '4px 8px',
        }}
      >
        <Avatar
          sx={{
            width: 20,
            height: 20,
            fontSize: '12px',
            backgroundColor: 'transparent'
          }}
        >
          {currentLanguage.flag}
        </Avatar>
        <Typography variant="body2" sx={{ fontSize: '12px', fontWeight: 500, color: 'inherit' }}>
          {currentLanguage.nativeName}
        </Typography>
        <ExpandMore fontSize="small" />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            mt: 1,
            minWidth: 180,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: '8px'
          }
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        disableScrollLock
      >
        {languages.map((language) => (
          <MenuItem
            key={language.code}
            onClick={() => handleLanguageChange(language.code)}
            selected={language.code === i18n.language}
            sx={{
              py: 1.5,
              px: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&:hover': {
                backgroundColor: 'action.hover'
              },
              '&.Mui-selected': {
                backgroundColor: 'action.selected',
                '&:hover': {
                  backgroundColor: 'action.hover'
                }
              }
            }}
          >
            <Avatar
              sx={{
                width: 24,
                height: 24,
                fontSize: '14px',
                backgroundColor: 'transparent'
              }}
            >
              {language.flag}
            </Avatar>
            <Typography
              variant="body2"
              sx={{
                fontWeight: language.code === i18n.language ? 600 : 400,
                color: language.code === i18n.language ? 'primary.main' : 'text.primary'
              }}
            >
              {language.nativeName}
            </Typography>
            {language.code === i18n.language && (
              <Check color="primary" fontSize="small" sx={{ ml: 'auto' }} />
            )}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default LanguageSelector;

